<div class="container-fluid pt-5 pb-5">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-4 col-sm-12 big-menu">
                <ul class="menu-holder rounded shadow-lg card w-100">
                    <li [ngClass]="{'active': currentPage == 'basic-info'}" (click)="selectPage('basic-info')">
                        <mat-icon>portrait</mat-icon>
                        Basic Info
                    </li>
                    <li [ngClass]="{'active': currentPage == 'favourite'}" (click)="selectPage('favourite')">
                        <mat-icon>thumb_up_alt</mat-icon>
                        Favourites
                    </li>
                    <li [ngClass]="{'active': currentPage == 'pending-property'}" (click)="selectPage('pending-property')">
                        <mat-icon>pending_actions</mat-icon>
                        Pending Properties
                    </li>
                    <li [ngClass]="{'active': currentPage == 'published-property'}" (click)="selectPage('published-property')">
                        <mat-icon>house</mat-icon>
                        Published Properties
                    </li>
                    <li [ngClass]="{'active': currentPage == 'expired-property'}" (click)="selectPage('expired-property')">
                        <mat-icon>schedule</mat-icon>
                        Expired Properties
                    </li>
                    <li [ngClass]="{'active': currentPage == 'change-password'}" (click)="selectPage('change-password')">
                        <mat-icon>vpn_key</mat-icon>
                        Change Password
                    </li>
                    <li [ngClass]="{'active': currentPage == 'change-phone'}" (click)="selectPage('change-phone')">
                        <mat-icon>add_ic_call</mat-icon>
                        Change Contact Detail
                    </li>
                </ul>
            </div>
            <div class="col-sm-12 mb-2 small-menu p-0">
                <div class="header">
                    <div class="header-title">
                        Profile
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menu for profile">
                        <mat-icon>menu</mat-icon>
                    </button>
                </div>
                
                <mat-menu #menu="matMenu">
                    <ul class="menu-holder rounded shadow-lg card w-100">
                        <li [ngClass]="{'active': currentPage == 'basic-info'}" (click)="selectPage('basic-info')">
                            <mat-icon>portrait</mat-icon>
                            Basic Info
                        </li>
                        <li [ngClass]="{'active': currentPage == 'favourite'}" (click)="selectPage('favourite')">
                            <mat-icon>thumb_up_alt</mat-icon>
                            Favourites
                        </li>
                        <li [ngClass]="{'active': currentPage == 'pending-property'}" (click)="selectPage('pending-property')">
                            <mat-icon>pending_actions</mat-icon>
                            Pending Properties
                        </li>
                        <li [ngClass]="{'active': currentPage == 'published-property'}" (click)="selectPage('published-property')">
                            <mat-icon>house</mat-icon>
                            Published Properties
                        </li>
                        <li [ngClass]="{'active': currentPage == 'expired-property'}" (click)="selectPage('expired-property')">
                            <mat-icon>schedule</mat-icon>
                            Expired Properties
                        </li>
                        <li [ngClass]="{'active': currentPage == 'change-password'}" (click)="selectPage('change-password')">
                            <mat-icon>vpn_key</mat-icon>
                            Change Password
                        </li>
                        <li [ngClass]="{'active': currentPage == 'change-phone'}" (click)="selectPage('change-phone')">
                            <mat-icon>add_ic_call</mat-icon>
                            Change Contact Detail
                        </li>
                    </ul>
                </mat-menu>
            </div>
            <div class="col-lg-9 col-md-8 col-sm-12 p-0">
                <div class="card min-height shadow-lg rounded w-100">
                    <app-basic-info *ngIf="currentPage == 'basic-info'"></app-basic-info>
                    <app-favourite *ngIf="currentPage == 'favourite'"></app-favourite>
                    <app-my-properties *ngIf="currentPage == 'pending-property'"></app-my-properties>
                    <app-published-property *ngIf="currentPage == 'published-property'"></app-published-property>
                    <app-expired-properties *ngIf="currentPage == 'expired-property'"></app-expired-properties>
                    <app-change-phone *ngIf="currentPage == 'change-phone'"></app-change-phone>
                    <app-change-password *ngIf="currentPage == 'change-password'"></app-change-password>
                </div>
            </div>
        </div>
    </div>
</div>